import React, { useState, useEffect, useRef } from "react"
import MetaTags from 'react-meta-tags';
import { Link , Redirect, useHistory} from "react-router-dom"
import Select, { AriaOnFocus } from "react-select"
import CreatableSelect from 'react-select/creatable';
import PropTypes from "prop-types"
import {showCloseableToast} from "helpers/function_helper"
import ReactDrawer from 'react-drawer';
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  InputGroup,
  Input,
  Label,
  Tooltip,
  NavLink,
  Progress,
  Row,
  TabContent,
  TabPane,
  Button,
  Badge,
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  UncontrolledDropdown
} from "reactstrap"

import { useReactToPrint } from "react-to-print";
import { useHotkeys } from 'react-hotkeys-hook';
import * as moment from "moment"
import classnames from "classnames"
import { useSelector, useDispatch } from "react-redux";
import SweetAlert from "react-bootstrap-sweetalert"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import SimpleBar from "simplebar-react"
//Import Breadcrumb
import { setTimeCounter } from "store/products/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import InvoiceDetailV4 from "../../components/Common/InvoiceDetailV4"
import InvoiceDetailV5 from "../../components/Common/InvoiceDetailV5"
import InvoiceDetailA5L from "../../components/Common/InvoiceDetailA5L"

import { getStockBalance as onGetStockBalanceDirect } from "helpers/backend_helper"

import RightDrawer from "../../components/Common/RightDrawer"
import Loader from "components/Common/Loader"
import { getAllCustomers as onGetAllCustomers } from "store/products/actions"
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { getLedgerDetails as onGetLedgerDetails } from "store/products/actions"
import { getProductsDropDown } from "helpers/backend_helper"
import { 
  getProductsDropDownFromCache,
  getStoreDetailsFromCache
 } from "helpers/cache_helper"

import COADropDown from "../../components/Product/COADropDown"
import { getNextNonDisabledField } from "helpers/function_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { getPreviousSalesId, getNextSalesId, getSalesEntryForEditDirect } from "helpers/backend_helper"

import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";

const SalesEntry = (props) => {

  
  const dispatch = useDispatch()
  const history = useHistory()
  const componentRef = useRef();
  const customerInputRef = useRef(null);
  const rateInputRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  const options = {
    filter: undefined,
    filterPreventDefault: true,
    enableOnTags: ['INPUT'],
    enabled: true,
    splitKey: '+',
    keyup: undefined,
    keydown: true
  };

  useHotkeys('enter', (event, handler)=> {
    //console.log('enter pressed')
    if(event.target.type == 'button'){
      return
    }
    const form = event.target.form;
    let index = [...form].indexOf(event.target);
    //skipping to loading charges, if no value is selected
    if(form.elements[index] && form.elements[index].id){
      const fieldId = form.elements[index].id
      if(fieldId.startsWith('sales-qty-')){
        const idx = fieldId.substring(10,11)
        if(salesRows[idx-1]){
          const lastSales = salesRows[idx-1]
          if(lastSales.productid == '' && lastSales.productqty == '0'){
            document.getElementById('loading-charges').focus();
            document.getElementById('loading-charges').select();
            return;
          }
        }
      }
    }

    const nextIdx = getNextNonDisabledField(index,form)
    form.elements[nextIdx].focus();
    if(form.elements[nextIdx].type == 'text' || form.elements[nextIdx].type == 'textarea'){
      form.elements[nextIdx].select();
    }
    event.preventDefault();
  }, options)

  useEffect(() => {
    dispatch(onGetAllCustomers(true))
    dispatch(onGetStoreSettings(true))
    dispatch(onGetLedgerDetails({'inputKey':'SALES_ACCOUNTS'},true))
    getPdtDropDown()
    fetchStoreDetails()
  }, [dispatch]);

  async function getPdtDropDown(){
    //const pdtdropdown = await getProductsDropDown()
    const pdtdropdown = await getProductsDropDownFromCache(true)
    setProductList(pdtdropdown)
  }

  const rateTypeOptions = [
    {
      label: "MRP",
      value: "mrp"
    },{
      label: "Retail",
      value: "retailprice"
    },{
      label: "Wholesale",
      value: "wholesaleprice"
    }
  ]

  const [tooltipOpen, setTooltipOpen] = useState(false)
  const toggle = () => setTooltipOpen(!tooltipOpen)

  const [enteredText, setEnteredText] = useState('')
  const [storeDetails, setStoreDetails] = useState({})
  const [savedSuccessFully, setSavedSuccessFully] = useState(false)
  const [showErrorPopUp, setShowErrorPopUp] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [isEdit, setIsEdit] = useState(false)

  const [showWarningPopUp, setShowWarningPopUp] = useState(false)
  const [warningMessage, setWarningMessage] = useState('')
  const [withTax, setWithTax] = useState(true)

  const [defaultCustomer, setDefaultCustomer] = useState()
  const [defaultSaleRateType, setDefaultSaleRateType] = useState()
  const [currentAddedValue, setCurrentAddedValue] = useState()
  const [newItemToAdd, setNewItemToAdd] = useState()
  const [position, setPosition] = useState()
  const [open, setOpen] = useState(false)
  const [showLoading, setShowLoading] = useState(false)
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [selectedRateType, setSelectedRateType] = useState(null)
  const [selectedSalesAccount, setSelectedSalesAccount] = useState(null)
  const [productList, setProductList] = useState([])
  const [salesEntryForEdit, setSalesEntryForEdit] = useState({})
  const [downloadCounter, setDownloadCounter] = useState(0)
  const [confirmationId, setConfirmationId] = useState('')
  const [printerPageSetting, setPrinterPageSetting] = useState('A4')
  
  useHotkeys('alt+ctrl+p,shift+cmd+p', ()=> {
    shortCutPrint()
  })

  const getAnewRow = (index) => {
    return { 
      idx: index , 
      id:"", 
      value: "",
      productid: "",
      productname: "",
      justproductname: "",
      productqty: "0",
      productrate: "0",
      productgross: "0",
      productdisc: "0",
      productgrosswithouttax: "0",
      productnet: "0",
      producttotal: "0",
      gstpercentage: "0",
      cgstpercentage: "0",
      sgstpercentage: "0",
      igstpercentage: "0",
      productcgst: "0",
      productsgst: "0",
      productigst: "0",
      productgst: "0",
      purchaserate: "0",
      profitamount: "0",
      profitwithouttax: "0",
      unitlist: [],
      selectedunitid: "",
      selectedunitname: "",
      hsncode: "",
      selectedunitoption: {},
      conversionrate: "1",
      effectiveproductqty: "0",
      purchaseaccountid : "",
      purchasediscountaccountid : "",
      purchasereturnaccountid :"",
      saleaccountid :"",
      salediscountaccountid :"",
      salereturnaccountid :"",
    }
  }

  const initializeSalesEntry = () => {
    return {
      invoicedate: moment(new Date()).format("yyyy-MM-DD HH:mm"),
      invoiceno: "",
      id:"",
      status:"",
      customerid: "",
      ratetype: "",
      salesaccountid: "",
      paymentaccountid: "",
      
      totalqty: "0",
      totalgross: "0",
      totaldisc: "0",
      totalgrosswithouttax: "0",
      totalcgst: "0",
      totalsgst: "0",
      totaligst: "0",
      totalgst: "0",
      totaltotal: "0",
  
      loadingcharges: "0",
      othercharges: "0",
      otherexpences: "0",
      discounts: "0",
      roundoff: "0",
      cashreceived: "0",
      grandtotal: "0",
      grandtotalbeforeround: "0",
      tendercash: "0",
      tenderbalance: "0",
      balanceamount: "0",
      totalprofitamount:"0",
      totalprofitwithouttaxamount: 0,
      notes: "",
      salesRows:[],
      salesRowsToRemove:[],
      sgstArray: [],
      cgstArray: [],
      igstArray: [],
    }
  }
  const [salesRows, setSalesRows] = useState([getAnewRow(1)])
  const [salesEntry, setSalesEntry] = useState(initializeSalesEntry())
  const [allStockBalance, setAllStockBalance] = useState({})
  const [profitDrp, setProfitDrp] = useState(false)

  const [validation, setValidation] = useState({
    invoicedate: null,
    suppinvoiceno: null,
  })

  const { customerList, settings, salesaccounts} = useSelector(state => ({
    customerList: state.Products.customers,
    settings: state.Products.settings,
    salesaccounts: state.Products.ledgers,
  }))

  function fetchStoreDetails(){
    getStoreDetailsFromCache(true).then(resp =>{
      setStoreDetails(resp)
    })
  }
  const {
    match: { params },
  } = props

  useEffect(() => {
    if (params && params.id) {
      setIsEdit(true)
      setShowLoading(true)
      getSalesEntryDetails(params.id)
    } 
  }, [])

  async function getSalesEntryDetails(pdtid){
    const response = await getSalesEntryForEditDirect(pdtid)
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.id){
      setSalesEntryForEdit((response))
    }
    setShowLoading(false)
  }

  useEffect(() => {
    if(isEdit && salesaccounts && salesaccounts.length > 0 && salesEntryForEdit && salesEntryForEdit.salesaccountid){
      const sAcntOption = salesaccounts.filter(each => each.value === salesEntryForEdit.salesaccountid)
      if(sAcntOption && sAcntOption.length == 1){
        setSelectedSalesAccount(sAcntOption[0])
      }
    }
    else if(salesaccounts && salesaccounts.length > 0){
      setSelectedSalesAccount(salesaccounts[0])
      setSalesEntry({
        ...salesEntry,
        salesaccountid: salesaccounts[0].value
      })
    }
  }, [salesaccounts]);

  useEffect(() => {

    if(currentAddedValue){
      const newlyAddedOption = customerList.filter(each => each.value === currentAddedValue)
      if(newlyAddedOption && newlyAddedOption.length == 1){
        setSelectedCustomer(newlyAddedOption[0])
        setSalesEntry({
          ...salesEntry,
          customerid : newlyAddedOption[0].value
        })
      }
    }
    else if(isEdit && customerList && customerList.length > 0 && salesEntryForEdit && salesEntryForEdit.customerid){
        const custOption = customerList.filter(each => each.value === salesEntryForEdit.customerid)
        if(custOption && custOption.length == 1){
          setSelectedCustomer(custOption[0])
          setSalesEntry({
            ...salesEntry,
            customerid : custOption[0].value
          })
        }
    }
    else if(customerList && customerList.length > 0){
      const custOption = customerList.filter(each => (each.value == '5000' || each.name == 'Guest'))
        if(custOption && custOption.length == 1){
          setDefaultCustomer(custOption[0])
          setSelectedCustomer(custOption[0])
          setSalesEntry({
            ...salesEntry,
            customerid : custOption[0].value
          })
        }
    }
  }, [customerList]);

  useEffect(() => {
    if (salesEntryForEdit && isEdit && params.id == salesEntryForEdit.id) {
      
      let salesRowsTemp = []
      let index = 1;

      salesEntryForEdit.salesRows.forEach(each => {
        let productname = ''
        let justproductname = ''
        let cgstper = '0'
        let sgstper = '0'
        let igstper = '0'
        let gstper = '0'
        let prodrate = '0'
        let purchaseratetemp = '0'
        let unitlisttemp = []
        let selectedunitoptiontemp = {}
        let conversionratetemp = '1'

        let purchaseaccountidtemp = ''
        let purchasediscountaccountidtemp = ''
        let purchasereturnaccountidtemp = ''
        let saleaccountidtemp = ''
        let salediscountaccountidtemp = ''
        let salereturnaccountidtemp = ''

        let hsncodetemp = ''

        if(productList && productList.length > 0){
          const foundValue = productList.filter(x => x["productid"] == each.productid)
          if(foundValue && foundValue.length == 1){
            productname = foundValue[0].label
            justproductname = foundValue[0].pdtname
            cgstper = foundValue[0].cgst
            sgstper = foundValue[0].sgst
            igstper = foundValue[0].igst
            gstper =  foundValue[0].gst
            hsncodetemp =  foundValue[0].hsncode

            purchaseaccountidtemp = foundValue[0].purchaseaccountid
            purchasediscountaccountidtemp = foundValue[0].purchasediscountaccountid
            purchasereturnaccountidtemp = foundValue[0].purchasereturnaccountid
            saleaccountidtemp = foundValue[0].saleaccountid
            salediscountaccountidtemp = foundValue[0].salediscountaccountid
            salereturnaccountidtemp = foundValue[0].salereturnaccountid

            unitlisttemp = foundValue[0].units
            const foundUnit = unitlisttemp.filter(x => x["unitid"] == each.selectedunitid)
            if(foundUnit && foundUnit.length == 1){
              selectedunitoptiontemp = foundUnit[0]
              conversionratetemp = foundUnit[0].conversionrate
            }
            //prodrate = foundValue[0][salesEntry.ratetype]
            //purchaseratetemp = foundValue[0].baseprice
          }
        }

        salesRowsTemp.push({
          ...each,
          idx: index++ , 
          value: each.id,
          productname: productname,
          justproductname: justproductname,
          cgstpercentage: cgstper,
          sgstpercentage: sgstper,
          igstpercentage: igstper,
          gstpercentage: gstper,
          hsncode: hsncodetemp,
          selectedunitoption: selectedunitoptiontemp,
          unitlist: unitlisttemp,
          conversionrate: conversionratetemp,
          purchaseaccountid : purchaseaccountidtemp,
          purchasediscountaccountid : purchasediscountaccountidtemp,
          purchasereturnaccountid :purchasereturnaccountidtemp,
          saleaccountid :saleaccountidtemp,
          salediscountaccountid :salediscountaccountidtemp,
          salereturnaccountid :salereturnaccountidtemp,
          //productrate: prodrate,
          //purchaserate: purchaseratetemp
        })
      })

      setSalesRows(salesRowsTemp)
      if(customerList && customerList.length > 0 && salesEntryForEdit.customerid){
        const custOption = customerList.filter(each => each.value === salesEntryForEdit.customerid)
        if(custOption && custOption.length == 1){
          setSelectedCustomer(custOption[0])
        }
      }

      if(salesaccounts && salesaccounts.length > 0 && salesEntryForEdit.salesaccountid){
        const sAcntOption = salesaccounts.filter(each => each.value === salesEntryForEdit.salesaccountid)
        if(sAcntOption && sAcntOption.length == 1){
          setSelectedSalesAccount(sAcntOption[0])
        }
      }

      setSalesEntry({
        ...salesEntry,
        id: salesEntryForEdit.id,
        status: salesEntryForEdit.status,
        invoicedate: salesEntryForEdit.invoicedate,
        customerid: salesEntryForEdit.customerid,
        ratetype: salesEntryForEdit.ratetype,
        invoiceno: salesEntryForEdit.invoiceno,
        paymentaccountid: salesEntryForEdit.paymentaccountid,
        totalqty: salesEntryForEdit.totalqty,
        totalgross: salesEntryForEdit.totalgross,
        totaldisc: salesEntryForEdit.totaldisc,
        //totalnet: salesEntryForEdit.totalnet,
        totalgrosswithouttax: salesEntryForEdit.totalgrosswithouttax,
        totalcgst: salesEntryForEdit.totalcgst,
        totalsgst: salesEntryForEdit.totalsgst,
        totaligst: salesEntryForEdit.totaligst,
        totalgst: salesEntryForEdit.totalgst,
        totaltotal: salesEntryForEdit.totaltotal,

        loadingcharges: salesEntryForEdit.loadingcharges,
        othercharges: salesEntryForEdit.othercharges,
        otherexpences: salesEntryForEdit.otherexpences,
        discounts: salesEntryForEdit.discounts,
        cashreceived: salesEntryForEdit.cashreceived,
        balanceamount: salesEntryForEdit.balanceamount,
        grandtotal: salesEntryForEdit.grandtotal,
        grandtotalbeforeround: salesEntryForEdit.grandtotal,
        roundoff: salesEntryForEdit.roundoff,
        tendercash: salesEntryForEdit.tendercash,
        tenderbalance: salesEntryForEdit.tenderbalance,
        totalprofitamount: salesEntryForEdit.totalprofitamount,
        totalprofitwithouttaxamount: salesEntryForEdit.totalprofitwithouttaxamount,
        notes: salesEntryForEdit.notes,
        salesRows:salesRowsTemp
      })
    }
  },[salesEntryForEdit])
  
  useEffect(() => {
    if(settings && settings.length > 0){
      const saleType = settings.filter(each => each.settingid == 'DEFAULT_SALE_RATE_TYPE')
      if(saleType && saleType.length > 0){
        const defaultsaletype = saleType[0].settingvalue
        const foundDefault = rateTypeOptions.filter(eachInn => eachInn.value == defaultsaletype)
        if(foundDefault){
          setSelectedRateType(foundDefault[0])
          setDefaultSaleRateType(foundDefault[0])
          setSalesEntry({
            ...salesEntry,
            ratetype : foundDefault[0].value
          })
        }
      }

      const printerPageSettingTemp = settings.filter(each => each.settingid == 'PRINTER_PAGE_SETTING')
      if(printerPageSettingTemp && printerPageSettingTemp.length > 0){
        const defaultPrinterPageSettingTemp = printerPageSettingTemp[0].settingvalue
        setPrinterPageSetting(defaultPrinterPageSettingTemp)
      }

    }
  }, [settings]);

  const mandatoryFields = ['invoicedate','customerid']

  const onChangeValidation = (fieldName, value) => {
    if(mandatoryFields.includes(fieldName)){
      const modifiedV = { ...validation }
      if (value !== "") {
        modifiedV[fieldName] = true
      } else {
        modifiedV[fieldName] = false
      }
      setValidation(modifiedV)
    }
  }

  useEffect(() => {
    let totalqtytemp = 0
    let totalgrosstemp = 0
    let totaldisctemp = 0
    //let totalnettemp = 0
    let totalgrosswithouttaxtemp = 0
    let totalcgsttemp = 0
    let totalsgsttemp = 0
    let totaligsttemp = 0
    let totalgsttemp = 0
    let totaltotaltemp = 0
    let totalprofitamounttemp = 0
    let totalprofitamountwotaxtemp = 0

    let sgstArray = []
    let cgstArray = []
    let igstArray = []

    //sgstGroupTotal
    salesRows.forEach(each => {
      totalqtytemp = totalqtytemp + Number(each["productqty"])
      totalgrosstemp = totalgrosstemp + Number(each["productgross"])
      totaldisctemp = totaldisctemp + Number(each["productdisc"])
      //totalnettemp = totalnettemp + Number(each["productnet"])
      totalgrosswithouttaxtemp = totalgrosswithouttaxtemp + Number(each["productgrosswithouttax"])
      totalcgsttemp = totalcgsttemp + Number(each["productcgst"])
      totalsgsttemp = totalsgsttemp + Number(each["productsgst"])
      totaligsttemp = totaligsttemp + Number(each["productigst"])
      totalgsttemp = totalgsttemp + Number(each["productgst"])
      totaltotaltemp = totaltotaltemp + Number(each["producttotal"])
      totalprofitamounttemp = totalprofitamounttemp + Number(each["profitamount"])
      totalprofitamountwotaxtemp = totalprofitamountwotaxtemp + Number(each["profitwithouttax"])

      if(withTax && Number(each["sgstpercentage"]) > 0){
        let filteredsgst =  sgstArray.filter(each1 => Number(each1.tax) == Number(each["sgstpercentage"]))
        if(filteredsgst && filteredsgst.length > 0){
          sgstArray = sgstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["sgstpercentage"])){
              return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productsgst"])
              }
            }
            else{
              return eachMapItem
            }
          })
        }
        else{
          sgstArray.push({
            tax: each["sgstpercentage"],
            taxamount: each["productsgst"],
            taxableamount : each["productgrosswithouttax"]
          })
        }
      }

      if(withTax && Number(each["cgstpercentage"]) > 0){
        let filteredcgst =  cgstArray.filter(each1 => Number(each1.tax) == Number(each["cgstpercentage"]))
        if(filteredcgst && filteredcgst.length > 0){
          cgstArray = cgstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["cgstpercentage"])){
              return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productcgst"])
              }
            }
            else{
              return eachMapItem
            }
          })
        }
        else{
          cgstArray.push({
            tax: each["cgstpercentage"],
            taxamount: each["productcgst"],
            taxableamount : each["productgrosswithouttax"]
          })
        }
      }

      if(withTax && Number(each["igstpercentage"]) > 0){
        let filteredigst =  igstArray.filter(each1 => Number(each1.tax) == Number(each["igstpercentage"]))
        if(filteredigst && filteredigst.length > 0){
          igstArray = igstArray.map(eachMapItem => {
            if(Number(eachMapItem.tax) == Number(each["igstpercentage"])){
              return {
                ...eachMapItem,
                taxableamount : Number(eachMapItem.taxableamount) + Number(each["productgrosswithouttax"]),
                taxamount : Number(eachMapItem.taxamount) + Number(each["productigst"])
              }
            }
            else{
              return eachMapItem
            }
          })
        }
        else{
          igstArray.push({
            tax: each["igstpercentage"],
            taxamount: each["productigst"],
            taxableamount : each["productgrosswithouttax"]
          })
        }
      }

    })

    let grandtotaltemp = Number(totaltotaltemp + Number(salesEntry.loadingcharges) + Number(salesEntry.othercharges) +  Number(salesEntry.otherexpences) - Number(salesEntry.discounts)).toFixed(2)
    const grandtotaltempafterround = Math.round(grandtotaltemp)
    const roundofftemp = grandtotaltempafterround - grandtotaltemp
    setSalesEntry({
      ...salesEntry,
      sgstArray : sgstArray,
      cgstArray : cgstArray,
      igstArray : igstArray,
      totalqty: Number(totalqtytemp).toFixed(2),
      totalgross: Number(totalgrosstemp).toFixed(2),
      totaldisc: Number(totaldisctemp).toFixed(2),
      //totalnet: Number(totalnettemp).toFixed(2),
      totalgrosswithouttax: Number(totalgrosswithouttaxtemp).toFixed(2),
      totalcgst: Number(totalcgsttemp).toFixed(2),
      totalsgst: Number(totalsgsttemp).toFixed(2),
      totaligst: Number(totaligsttemp).toFixed(2),
      totalgst: Number(totalgsttemp).toFixed(2),
      totaltotal: Number(totaltotaltemp).toFixed(2),
      cashreceived: isEdit? salesEntry.cashreceived : Number(0).toFixed(2), //incase of edit, just keeping the same amount
      roundoff: Number(roundofftemp).toFixed(2),
      balanceamount: isEdit? (Number(grandtotaltempafterround) - Number(salesEntry.cashreceived)) : Number(grandtotaltempafterround).toFixed(2),
      grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
      grandtotal: Number(grandtotaltempafterround).toFixed(2),
      tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
      totalprofitamount: Number(totalprofitamounttemp).toFixed(2),
      totalprofitwithouttaxamount: Number(totalprofitamountwotaxtemp).toFixed(2),
      salesRows:salesRows
    })
  }, [salesRows]);

  function getGrossFromRow(currentRow){
    if(isNumber(currentRow["productqty"]) && isNumber(currentRow["productrate"])){
      return (Number(currentRow["productqty"]) * Number(currentRow["productrate"])).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getGrossWithoutTaxFromRow(currentRow){

    if(!withTax){
      if(isNumber(currentRow["productqty"]) && isNumber(currentRow["productrate"])){
        //qty * product rate
        return (Number(currentRow["productqty"]) * (Number(currentRow["productrate"]))).toFixed(2)
      }
      else{
        return Number(0).toFixed(2)
      }
    }

    if(isNumber(currentRow["productqty"]) && isNumber(currentRow["productrate"]) && isNumber(currentRow["gstpercentage"])){
      //qty * product rate / 1.gst
      return (Number(currentRow["productqty"]) * (Number(currentRow["productrate"]) / ( 1 + (Number(currentRow["gstpercentage"])) /100) )).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getNetFromRow(currentRow){
    
    if(isNumber(currentRow["productgst"]) && isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["productdisc"])){
      return (Number(currentRow["productgrosswithouttax"]) + Number(currentRow["productgst"]) - currentRow["productdisc"]).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getCGSTFromRow(currentRow){

    if(!withTax){
      return Number(0).toFixed(2)
    }

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }
    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["cgstpercentage"])){
      return (( (currentRow["productgrosswithouttax"] - discount ) * currentRow["cgstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getSGSTFromRow(currentRow){

    if(!withTax){
      return Number(0).toFixed(2)
    }

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }

    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["sgstpercentage"])){
      return (((currentRow["productgrosswithouttax"] - discount )  * currentRow["sgstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getIGSTFromRow(currentRow){

    if(!withTax){
      return Number(0).toFixed(2)
    }

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }

    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["igstpercentage"])){
      return (((currentRow["productgrosswithouttax"] - discount )  * currentRow["igstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getGSTFromRow(currentRow){

    if(!withTax){
      return Number(0).toFixed(2)
    }

    let discount = 0
    if(isNumber(currentRow["productdisc"])){
      discount = Number(currentRow["productdisc"])
    }

    if(isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["gstpercentage"])){
      return (((currentRow["productgrosswithouttax"] - discount )  * currentRow["gstpercentage"])/100).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  function getTotalFromRow(currentRow){
    //const total = Number(currentRow["productnet"]) + Number(currentRow["productcgst"]) + Number(currentRow["productsgst"]) + Number(currentRow["productigst"])
    //return Number(total).toFixed(2)
    if(isNumber(currentRow["productgst"]) &&  isNumber(currentRow["productgrosswithouttax"]) && isNumber(currentRow["productdisc"])){
      return (Number(currentRow["productgrosswithouttax"]) + Number(currentRow["productgst"]) - currentRow["productdisc"]).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }
  function getProfitForEachFromRow(currentRow){
    if(isNumber(currentRow["producttotal"]) && isNumber(currentRow["productqty"])){
      return (Number(currentRow["producttotal"]) - (Number(currentRow["purchaserate"]) * Number(currentRow["productqty"]))).toFixed(2)
    }
    else{
      return Number(0).toFixed(2)
    }
  }

  useEffect(()=>{
    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.map(eachRow => {
      eachRow = recalculateEachRow(eachRow)
      return {
        ...eachRow
      }
    })
    setSalesRows(modifiedRows)
  },[withTax])

  function getProfitWithoutTaxForEachFromRow(currentRow){
    if(!withTax){
      return (Number(currentRow["profitamount"])).toFixed(2)
    }
    //console.log('currentRow["profitamount"]',currentRow["profitamount"])
    //console.log('currentRow["gstpercentage"]',currentRow["gstpercentage"])
    //console.log('currentRow["productgst"]',currentRow["productgst"])
    //console.log('1 + currentRow["gstpercentage"]',(1+(Number(currentRow["gstpercentage"])/100)))
    var discEachRow = 0;
    if(isNumber(currentRow["productdisc"])){
      discEachRow = currentRow["productdisc"]
    }
    
    return (((Number(currentRow["productrate"]) - (Number(currentRow["purchaserate"] * (1+(Number(currentRow["gstpercentage"])/100))))) * Number(currentRow["productqty"])) - discEachRow).toFixed(2)
    //return (Number(currentRow["profitamount"]) - Number(currentRow["productgst"])).toFixed(2)
  }

  function handleRateTypeChange(ratetypeinp){
    setSalesEntry({
      ...salesEntry,
      ratetype : ratetypeinp
    })

    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.map(eachRow => {
      let prodrate = eachRow["selectedunitoption"][ratetypeinp]
      /*
      if(productList && productList.length > 0){
        const foundValue = productList.filter(x => x["productid"] == eachRow.productid)
        if(foundValue && foundValue.length == 1){
          prodrate = foundValue[0][ratetypeinp]
        }
      }*/
      eachRow["productrate"] = prodrate
      eachRow = recalculateEachRow(eachRow)
      return {
        ...eachRow,
        productrate : prodrate
      }
    })
    setSalesRows(modifiedRows)
  }

  function handleUnitChangeV2(id, selected) {
    var modifiedRows = [...salesRows]
      modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){

        eachRow["selectedunitoption"] = selected
        eachRow["selectedunitid"] = selected.unitid
        eachRow["selectedunitname"] = selected.name
        eachRow["productrate"] = selected[salesEntry.ratetype]
        eachRow["purchaserate"] = selected.baseprice
        eachRow["conversionrate"] = selected.conversionrate
        eachRow["effectiveproductqty"] = (Number(eachRow["productqty"]) / Number(selected.conversionrate)).toFixed(3)
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }

  function getStockBalance(salesRow, productoption){
    if(productoption && productoption.trackinventory && productoption.productid && isNumber(productoption.stockalertlevel)){
      onGetStockBalanceDirect({'inputKey':productoption.productid}).then(resp =>{
        if(resp && resp.stockbalance){
          setAllStockBalance({
            ...allStockBalance,
            [productoption.productid] : resp.stockbalance
          })
          if(Number(resp.stockbalance) < Number(productoption.stockalertlevel)){
            showCloseableToast('Stock Balance : '+resp.stockbalance +' '+ productoption.unitname,'bottom-left','error')
          }
          else if(Number(resp.stockbalance) == Number(productoption.stockalertlevel)){
            showCloseableToast('Stock Balance : '+resp.stockbalance+' '+ productoption.unitname,'bottom-left','warning')
          }
          else{
            showCloseableToast('Stock Balance : '+resp.stockbalance+' '+ productoption.unitname,'bottom-left','info')
          }

          if(salesRow.productqty && Number(salesRow.productqty) > 0){
            if(Number(resp.stockbalance) < Number(salesRow.productqty)){
              setWarningMessage('Entered quantity ('+salesRow.productqty+') is more than available ('+resp.stockbalance+'). Please check you have enough balance.')
              setShowWarningPopUp(true)
            }
          }
        }
      })
    }
  }

  function checkAndAlertStockStatus(salesRow, qty){
    if(salesRow.trackinventory && allStockBalance && allStockBalance[salesRow.productid]){
      if(Number(allStockBalance[salesRow.productid]) < Number(qty)){
        setWarningMessage('Entered quantity ('+qty+') is more than available ('+allStockBalance[salesRow.productid]+'). Please check you have enough balance.')
        setShowWarningPopUp(true)
      }
    }
  }

  function handleProductChangeV2(id, productoption) {
    
    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        getStockBalance(eachRow, productoption)
        const defaultunit = productoption.units[0]
        eachRow["selectedunitid"] = defaultunit.unitid
        eachRow["selectedunitname"] = defaultunit.name
        
        eachRow["selectedunitoption"] = defaultunit
        eachRow["unitlist"] = productoption.units
        eachRow["productrate"] = defaultunit[salesEntry.ratetype]
        eachRow["purchaserate"] = defaultunit.baseprice
        eachRow["conversionrate"] = defaultunit.conversionrate

        eachRow["cgstpercentage"] = productoption.cgst
        eachRow["sgstpercentage"] = productoption.sgst
        eachRow["igstpercentage"] = productoption.igst
        eachRow["gstpercentage"] = productoption.gst

        eachRow = recalculateEachRow(eachRow)

        showCloseableToast('PR : '+eachRow.purchaserate+', SR: '+ eachRow.productrate,'bottom-left','info')

        return {
          ...eachRow,
          //id:productoption.productid, 
          //value: productoption.productid,
          productid: productoption.productid,
          productname: productoption.label,
          justproductname: productoption.pdtname,
          cgstpercentage: productoption.cgst,
          sgstpercentage: productoption.sgst,
          igstpercentage: productoption.igst,
          gstpercentage: productoption.gst,
          hsncode: productoption.hsncode,
          purchaseaccountid : productoption.purchaseaccountid,
          purchasediscountaccountid : productoption.purchasediscountaccountid,
          purchasereturnaccountid :productoption.purchasereturnaccountid,
          saleaccountid :productoption.saleaccountid,
          salediscountaccountid :productoption.salediscountaccountid,
          salereturnaccountid :productoption.salereturnaccountid,
          trackinventory : productoption.trackinventory,
          stockalertlevel : productoption.stockalertlevel
          //productrate: productoption[salesEntry.ratetype],
          //purchaserate: productoption.baseprice,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }

  function handleQtyChangeV2(id, value) {
    var modifiedRows = [...salesRows]

    modifiedRows = modifiedRows.map(eachRow => {

      if(eachRow["idx"] == id){
        checkAndAlertStockStatus(eachRow, value)
        eachRow["productqty"] = value
        eachRow["effectiveproductqty"] = (Number(value) / Number(eachRow["conversionrate"])).toFixed(3)
        eachRow = recalculateEachRow(eachRow)

        return {
          ...eachRow,
          productqty: value,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }

  function recalculateEachRow(eachRow){

    eachRow["productgross"] = getGrossFromRow(eachRow)
    eachRow["productgrosswithouttax"] = getGrossWithoutTaxFromRow(eachRow)
    
    eachRow["productcgst"] = getCGSTFromRow(eachRow)
    eachRow["productsgst"] = getSGSTFromRow(eachRow)
    eachRow["productigst"] = getIGSTFromRow(eachRow)
    eachRow["productgst"] = getGSTFromRow(eachRow)
    eachRow["productnet"] = getNetFromRow(eachRow)
    eachRow["producttotal"] = getTotalFromRow(eachRow)

    eachRow["profitamount"] = getProfitForEachFromRow(eachRow)
    eachRow["profitwithouttax"] = getProfitWithoutTaxForEachFromRow(eachRow)

    return eachRow
  }

  function handleRateChangeV2(id, value) {
    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        eachRow["productrate"] = value
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productrate: value,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }

  function handleDiscountChangeV2(id, value) {
    var modifiedRows = [...salesRows]

    modifiedRows = modifiedRows.map(eachRow => {
      if(eachRow["idx"] == id){
        eachRow["productdisc"] = value
        eachRow = recalculateEachRow(eachRow)
        return {
          ...eachRow,
          productdisc: value,
        }
      }
      else {
        return eachRow
      }
    })
    setSalesRows(modifiedRows)
  }


  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  const onDrawerClose = () => {
    rateInputRef.current.focus();
    setOpen(false);
  }

  const onNewlyAddedValue = (value) => {
    setCurrentAddedValue(value)
  }

  function validatePdtChange(key,value){
    if(value && value != ""){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:false
      })
    }  
  }

  function validateTextNumberInput(key,value){
    if(value && value != "" && isNumber(value) && Number(value) > 0){
      setValidation({
        ...validation,
        [key]:true
      })
    }
    else{
      setValidation({
        ...validation,
        [key]:true
      })
    }
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    let finalSalesRows = []

    for (let index = 0; index < salesRows.length; index++) {
      const lastRow = salesRows[index];

      if(index>0 && lastRow["productid"] == "" && (lastRow["productqty"] == "" || lastRow["productqty"] == "0")){
        continue;
      }

      finalSalesRows.push(lastRow)

      if(lastRow["productid"] && lastRow["productid"] != ""){
        modifiedV["pdtitem-"+(index+1)] = true
      }
      else{
        modifiedV["pdtitem-"+(index+1)] = false
        formValid = false
      }
  
      if(lastRow["productqty"] && lastRow["productqty"] != "" && isNumber(lastRow["productqty"]) && Number(lastRow["productqty"]) > 0){
        modifiedV["productqty-"+(index+1)] = true
      }
      else{
        modifiedV["productqty-"+(index+1)] = false
        formValid = false
      }
  
      if(lastRow["productrate"] && lastRow["productrate"] != "" && isNumber(lastRow["productrate"]) && Number(lastRow["productrate"]) > 0){
        modifiedV["productrate-"+(index+1)] = true
      }
      else{
        modifiedV["productrate-"+(index+1)] = false
        formValid = false
      }
    }

    setSalesRows(finalSalesRows)

    setValidation(modifiedV)
    return formValid
  }

  function validateFormSubmit(){
    let formValid = true;
    const modifiedV = { ...validation }
    mandatoryFields.forEach(eachItem =>{
      if(salesEntry[eachItem] && salesEntry[eachItem].trim() != ""){
        modifiedV[eachItem] = true
      }
      else{
        modifiedV[eachItem] = false
        formValid = false
      }
    })
    setValidation(modifiedV)

    return formValid
  }

  function addSalesEntry(){
    let isFormValid = validateFormSubmit()
    if(isFormValid){
      isFormValid = validateForm()
    }
    if(isFormValid){
      const salesEntryTemp = { ...salesEntry }
      salesEntryTemp["status"] = 'ACTIVE'
      submitCreateNewSalesEntry(salesEntryTemp)
    }
  }

  function draftSalesEntry(){
      const salesEntryTemp = { ...salesEntry }
      salesEntryTemp["status"] = 'DRAFT'
      submitCreateNewSalesEntry(salesEntryTemp)
  }

  function updateDraftSalesEntry(){
    const salesEntryTemp = { ...salesEntry }
    salesEntryTemp["status"] = 'DRAFT'
    submitUpdateSalesEntry(salesEntryTemp)
  }

  function updateSalesEntry(){
    let isFormValid = validateFormSubmit()
    if(isFormValid){
      isFormValid = validateForm()
    }
    if(isFormValid){
      const salesEntryTemp = { ...salesEntry }
      salesEntryTemp["status"] = 'ACTIVE'
      submitUpdateSalesEntry(salesEntryTemp)
    }
  }

  async function submitUpdateSalesEntry(salesEntryDetails) {
    setShowLoading(true)
    const response = await onEditItemDirect(salesEntryDetails, 'SalesEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      setConfirmationId(salesEntryDetails.id)
      setShowSuccessPopUp(true)
      setSuccessMessage('Sales Entry Updated successfully.')
      document.getElementById('sales-print-id').focus();
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  async function submitCreateNewSalesEntry(salesEntryDetails) {
    setShowLoading(true)
    const response = await onAddItemDirect(salesEntryDetails, 'SalesEntry')
    if(response && response.status === 'failure'){
      setShowErrorPopUp(true)
      setErrorMessage(response.errorResponse)
    }
    else if(response && response.status === 'success'){
      setConfirmationId(response.responseId)
      setSalesEntry({
        ...salesEntry,
        invoiceno:response.confirmation_code
      })
      
      setSavedSuccessFully(true)
      setShowSuccessPopUp(true)
      setSuccessMessage('Sales Entry added successfully.')
      document.getElementById('sales-print-id').focus();
    }
    dispatch(setTimeCounter(1500000))
    setShowLoading(false)
  }

  function handleRemoveOneRow(formRow, id) {

    var modifiedRows = [...salesRows]
    modifiedRows = modifiedRows.filter(x => x["idx"] !== id)

    var updatedRows = [];
    modifiedRows.map((row,index) =>{
      updatedRows.push(
        {
          ...row, 
          idx: index+1
        })
    })

    setSalesRows(updatedRows)

    const currentRows = salesEntry.salesRowsToRemove
    currentRows.push(formRow.id)
    setSalesEntry({
      ...salesEntry,
      salesRowsToRemove : currentRows
    })
  }

  function addMoreDetails(idx) {

    let currentRows = [...salesRows]
    currentRows.push(getAnewRow(salesRows.length+1))
    setSalesRows(currentRows)
  }

  function getSelectedProduct(idx){
    if(productList && salesRows && productList.length > 0 && salesRows.length > 0){
      const foundValue = productList.filter(x => x["productid"] == salesRows[idx-1].productid)
      return foundValue
    }
  }

  function getSelectedUnit(row,idx){
    if(row.unitlist && row.unitlist > 0){
      const foundValue = row.unitlist.filter(x => x["unitid"] == salesRows[idx-1].selectedunitid)
      return foundValue
    }
  }

  function addNewItem(item) {
    setPosition('right')
    setOpen(!open)
    setNewItemToAdd(item)
  }

  function addNewSales(){
    setSalesRows([getAnewRow(1)])
    const baseSales = initializeSalesEntry()
    setSelectedSalesAccount(salesaccounts[0])
    setSelectedRateType(defaultSaleRateType)
    setSelectedCustomer(defaultCustomer)
    setSavedSuccessFully(false)
    setSalesEntry({
      ...baseSales,
      salesaccountid: salesaccounts[0].value,
      ratetype: defaultSaleRateType.value,
      customerid: defaultCustomer.value
    })
  }

  useEffect(() => {
    if(downloadCounter > 0){
      const input = document.getElementById('invoice-detail-toprint');
      html2canvas(input, {
        scale:2,
        dpi: 144,
        })
        .then((canvas) => {

          /*
          var a = document.createElement('a');
          a.href = canvas.toDataURL("image/png");
          a.download = 'myfile.png';
          a.click();
          */
          
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF();
          //pdf.addImage(imgData, 'JPEG', 0, 0);
          pdf.addImage(imgData, "JPEG", -5, 0, ((canvas.width/2)*.275), ((canvas.height/2)*.275));
          pdf.save("download.pdf");
          /*
          pdf.autoPrint();

          const hiddFrame = document.createElement('iframe');
          hiddFrame.style.position = 'fixed';
          // "visibility: hidden" would trigger safety rules in some browsers like safari，
          // in which the iframe display in a pretty small size instead of hidden.
          // here is some little hack ~
          hiddFrame.style.width = '1px';
          hiddFrame.style.height = '1px';
          hiddFrame.style.opacity = '0.01';
          const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
          if (isSafari) {
            // fallback in safari
            hiddFrame.onload = () => {
              try {
                hiddFrame.contentWindow.document.execCommand('print', false, null);
              } catch (e) {
                hiddFrame.contentWindow.print();
              }
            };
          }
          hiddFrame.src = pdf.output('bloburl');
          document.body.appendChild(hiddFrame);
          */
          
          
        })
      ;
    }
  }, [downloadCounter])

  const onContinueEditing = () => {
    if(confirmationId != ''){
      if(isEdit){
        setShowLoading(true)
        getSalesEntryDetails(confirmationId)
      }
      history.push('/edit-salesentry/'+confirmationId);
    }
  }

  const onCreateNewSales = () => {
      if(isEdit){
        history.push('/add-sales');
      }
      else{
        addNewSales()
    }
  }

  function downLoadInvoice(){
    setDownloadCounter(downloadCounter + 1)
  }

  const goToLastSales = async () => {
    setShowLoading(true)
    const resp = await getPreviousSalesId({})
    if(resp && resp.status && resp.status == 'success' && resp.confirmation_code){
      history.push('/edit-salesentry/'+resp.confirmation_code);
    }
    else{
      setShowLoading(false)
      setErrorMessage('No more entries')
      setShowErrorPopUp(true)
    }
  }

  const goToPreviousSales = async () => {
    setShowLoading(true)
    const resp = await getPreviousSalesId({
      key: params.id
    })
    if(resp && resp.status && resp.status == 'success' && resp.confirmation_code){
      history.push('/edit-salesentry/'+resp.confirmation_code);
      getSalesEntryDetails(resp.confirmation_code)
    }
    else{
      setShowLoading(false)
      setErrorMessage('No more entries')
      setShowErrorPopUp(true)
    }
  }
  
  const goToNextSales = async () => {
    setShowLoading(true)
    const resp = await getNextSalesId({
      key: params.id
    })
    if(resp && resp.status && resp.status == 'success' && resp.confirmation_code){
      history.push('/edit-salesentry/'+resp.confirmation_code);
      getSalesEntryDetails(resp.confirmation_code)
    }
    else{
      setShowLoading(false)
      setErrorMessage('No more entries')
      setShowErrorPopUp(true)
    }
  }

  function shortCutPrint(){
    if(!isEdit && savedSuccessFully){
      handlePrint()
    }
    else if(isEdit){
      handlePrint()
    }
  }

  return (
    <React.Fragment>
      <div className="page-content sales-entry-form">
        <MetaTags>
          <title>Sales Entry | Flamingo</title>
        </MetaTags>
        <Loader showLoader={showLoading} />
        <Container fluid>
          {/*isEdit ? 
          <Breadcrumbs title="Sales" breadcrumbItem="Edit Sales Entry" /> 
          :
          <Breadcrumbs title="Sales" breadcrumbItem="Sales Entry" />
          */}
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="pt-2">
                  <Form>
                    <Row className="mb-2">
                      <Col></Col>
                      <Col className="text-center font-size-18 fw-bold"><span className="px-3 bg-light ">Sales Entry</span></Col>
                      <Col className="text-end">
                        {!isEdit && <Button
                          color="primary"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            goToLastSales()
                          }}
                          >
                            <i className="mdi mdi-chevron-left me-1"></i>
                            Previous
                        </Button>
                        }

                        {isEdit && <Button
                          color="primary"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            goToPreviousSales()
                          }}
                          >
                            <i className="mdi mdi-chevron-left me-1"></i>
                            Previous
                        </Button>
                        }

                        {isEdit && <Button
                          color="primary"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            goToNextSales()
                          }}
                          >
                            Next
                            <i className="mdi mdi-chevron-right ms-1"></i>
                        </Button>
                        }
                        {!isEdit && !savedSuccessFully && <Button
                          color="warning"
                          className="btn btn-primary btn-sm me-2"
                          onClick={() => {
                            addNewSales()
                          }}
                          >
                            <i className="mdi mdi-text-box-remove-outline me-1"></i>
                            Clear
                        </Button> 
                        }
                        {isEdit && <Button
                          color="primary"
                          className="btn btn-warning btn-sm me-2"
                          onClick={() => {
                            onCreateNewSales()
                          }}
                          > 
                          <i className="mdi mdi-plus me-1" />
                            ADD NEW SALES
                        </Button>
                        }
                      </Col>
                    </Row>
                    <Row className="mb-0">
                      <Col lg="6" className="mb-0">
                        <Row>
                          <Col lg="4">
                            <FormGroup className="mb-1">
                              <Label>Invoice Date</Label>
                              <InputGroup>
                                <Flatpickr
                                  id="invoicedatefp"
                                  className="form-control d-block"
                                  placeholder="dd MM yyyy H:i"
                                  value={salesEntry.invoicedate}
                                  options={{
                                    enableTime: true,
                                    altInput: true,
                                    altFormat: "j M Y, H:i",
                                    dateFormat: "Y-m-d H:i",
                                  }}
                                  onChange={date => {
                                    const date1 = moment(new Date(date)).format("yyyy-MM-DD HH:mm ")
                                    setSalesEntry({
                                      ...salesEntry,
                                      invoicedate : date1
                                    })
                                    onChangeValidation("invoicedate", date1)
                                  }}
                                />
                                {(validation["invoicedate"] === false) &&
                                  <div className="custom-error">
                                    Please select the Invoice Date
                                  </div>
                                }
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          {/*<Col lg="5">
                            <FormGroup className="mb-4">
                              <Label>Sales Account</Label>
                                <Select
                                  onChange={(e) => {
                                    setSalesEntry({
                                      ...salesEntry,
                                      salesaccountid : e.value
                                    })
                                    setSelectedSalesAccount(e)
                                  }}
                                  value={selectedSalesAccount}
                                  options={salesaccounts}
                                  classNamePrefix="select2-selection"
                                  isLoading={false}
                                  id="salesaccount"
                                />
                            </FormGroup>
                                </Col>*/}
                          <Col lg="8">
                            <FormGroup className="mb-1">
                              <Label>Customer</Label>
                                <CreatableSelect
                                  onChange={(e) => {
                                    setSalesEntry({
                                      ...salesEntry,
                                      customerid : e.value
                                    })
                                    setSelectedCustomer(e)
                                    onChangeValidation("customerid", e.value)
                                  }}
                                  value={selectedCustomer}
                                  options={customerList}
                                  classNamePrefix="select2-selection"
                                  isLoading={false}
                                  ref={customerInputRef}
                                  autoFocus={true}
                                  id="productcustomer"
                                  onCreateOption={(e) => {
                                    setEnteredText(e)
                                    addNewItem('Customer')
                                  }}
                                />
                                {(validation["customerid"] === false) &&
                                  <div className="custom-error">
                                    Please select the Customer
                                  </div>
                                }
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="6" className="mb-0">
                        <Row className="mb-0">
                          <Col lg="3" className="mb-0">
                            <FormGroup className="mb-1">
                              <Label>Rate</Label>
                                <Select
                                  onChange={(e) => {
                                    handleRateTypeChange(e.value)
                                    setSelectedRateType(e)
                                  }}
                                  ref={rateInputRef}
                                  value={selectedRateType}
                                  options={rateTypeOptions}
                                  classNamePrefix="select2-selection"
                                />
                            </FormGroup>
                          </Col>
                          <Col lg="2" className="mb-0">
                            <div className="mb-0">
                              <Label for="productactive">
                                Taxable
                              </Label>
                              <div className="square-switch mt-1">
                                <input
                                  type="checkbox"
                                  id="square-switch1"
                                  switch="none"
                                  checked={withTax}
                                  onChange={() => {
                                    setWithTax(!withTax)
                                  }}
                                />
                                <label
                                  htmlFor="square-switch1"
                                  data-on-label="Yes"
                                  data-off-label="No"
                                />
                              </div>
                            </div>
                          </Col>
                          
                          {isEdit && <Col className="ms-3" lg="4">
                            <FormGroup className="mb-1">
                              <Label>No.
                              <Badge className={salesEntry.status== "ACTIVE"? "ms-2 font-size-12 bg-success badge-success":"ms-2 font-size-12 bg-warning badge-warning"}>
                                {salesEntry.status}
                              </Badge>
                              </Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  disabled
                                  value={salesEntry.invoiceno || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          }
                          <Col>
                            {Number(salesEntry.grandtotal) > 0 && <Row>
                              <Col lg="12" className="text-end">
                                <Dropdown
                                  direction="up"
                                  isOpen={profitDrp}
                                  toggle={() => {
                                    setProfitDrp(!profitDrp)
                                  }}
                                >
                                  <DropdownToggle
                                    className="btn "
                                    href="#"
                                    tag="i"
                                    onClick={(e) => {e.stopPropagation()}}
                                  >
                                    <i className="fas fa-eye" />
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
                                    <div className="px-lg-2 p-2 ms-2 me-2">
                                      <dl className="row mb-0">
                                      <dt className="col-sm-12 text-center">Profit</dt>
                                      <hr className="mb-1"/>
                                      <dt className="col-sm-6 text-center">Item</dt>
                                      <dt className="col-sm-3">Purchase Rate</dt>
                                      <dt className="col-sm-3 ">Amount</dt>
                                      <hr className="mb-1"/>
                                      {(salesRows || []).map((formRow, key) => (
                                        formRow.productid != '' && <React.Fragment key={key}>
                                          <dt className="col-sm-6 text-truncate">{formRow.productname}</dt>
                                          <dd className="col-sm-3">{Number(Number(formRow.purchaserate) * (1+(Number(formRow.gstpercentage)/100))).toLocaleString('en-IN',{minimumFractionDigits: 2, maximumFractionDigits: 2})}</dd>
                                          <dd className="col-sm-3"><i className="bx bx-rupee "></i>{Number(formRow.profitwithouttax).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                        </React.Fragment>
                                      ))}
                                      <hr className="mb-1"/>
                                      {salesEntry.discounts && salesEntry.discounts != '0' && 
                                      <>
                                        <dt className="col-sm-9 text-truncate">Discounts</dt>
                                        <dd className="col-sm-3"><i className="bx bx-rupee "></i>{Number(salesEntry.discounts).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                        <hr className="mb-1"/>
                                      </>
                                      }
                                      <dt className="col-sm-9 text-center">Total</dt>
                                      <dd className="col-sm-3 "><i className="bx bx-rupee "></i>{Number((salesEntry.totalprofitwithouttaxamount)-Number(salesEntry.discounts)).toLocaleString('en-IN',{minimumFractionDigits: 2})}</dd>
                                    
                                      </dl>
                                    </div>
                                  </DropdownMenu>
                                </Dropdown>
                              </Col>
                            </Row>}
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <div className="inner-repeater mb-1">
                      <div className="table-responsive">
                        <table style={{ width: "100%" }} className="0">
                          <tbody>
                            <tr className="">
                              <td>
                                <Row className="me-3 no-gutters custom-table-sales-header">
                                  <Col lg="5" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="1">#</Col>
                                      <Col className="custom-table-header-cell" xs="11">Item</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="3" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Qty</Col>
                                      <Col className="custom-table-header-cell" xs="3">Unit</Col>
                                      <Col className="custom-table-header-cell" xs="3">Rate</Col>
                                      <Col className="custom-table-header-cell" xs="3">Gross</Col>
                                      
                                      
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="custom-table-header-cell" xs="3">Base Rate</Col>
                                      {/*<Col className="custom-table-header-cell" xs="2">CGST</Col>
                                      <Col className="custom-table-header-cell" xs="2">SGST</Col>
                                      <Col className="custom-table-header-cell" xs="1">IGST</Col>*/}
                                      <Col className="custom-table-header-cell" xs="2">Disc</Col>
                                      <Col className="custom-table-header-cell" xs="2">GST</Col>
                                      <Col className="custom-table-header-cell" xs="3">Total</Col>
                                      <Col className="custom-table-header-cell" xs="2">Add</Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>

                            <tr><td>
                            <SimpleBar style={{ height: "170px"}} autoHide={false}>
                            {(salesRows || []).map((formRow, key) => (
                              <tr key={key}>
                                <td>
                                  <Row className="no-gutters">
                                    <Col lg="5" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="1">
                                          <Input
                                            type="text"
                                            className="nopadd text-center"
                                            disabled
                                            value={formRow.idx}
                                          />
                                        </Col>
                                        <Col xs="11">
                                          <Select
                                            onChange={(e) => {
                                              handleProductChangeV2(formRow.idx, e)
                                              validatePdtChange("pdtitem-"+formRow.idx, e.productid)
                                            }}
                                            formatOptionLabel={({ value, label, mrp }) => (
                                              <div style={{ display: "flex", justifyContent: "space-between", alignContent:"center", alignItems:"center" }}>
                                                <div>{label}</div>
                                                <div style={{ marginLeft: "10px", color: "#ccc", fontSize:"12px"}}>{""}{mrp}</div>
                                              </div>
                                            )}
                                            options={productList}
                                            classNamePrefix="select2-selection rd"
                                            isLoading={false}
                                            id={"productentry-"+key}
                                            menuPortalTarget= {document.body}
                                            autoFocus={key==0?false:true}
                                            value={getSelectedProduct(formRow.idx)}
                                          />
                                          {(validation["pdtitem-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select the Item
                                            </div>
                                          }
                                        </Col>
                                      </Row>
                                    </Col>
                                    <Col lg="3" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            id={"sales-qty-"+formRow.idx}
                                            type="text" //Qty
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleQtyChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productqty-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productqty)}
                                          />
                                          {(validation["productqty-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Qty
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Select
                                            onChange={(e) => {
                                              handleUnitChangeV2(formRow.idx, e)
                                              //handleProductChangeV2(formRow.idx, e)
                                              //validatePdtChange("pdtitem-"+formRow.idx, e.productid)
                                            }}
                                            components={{
                                              DropdownIndicator: () => null,
                                              IndicatorSeparator: () => null
                                            }}
                                            options={(salesRows.filter(x => x["idx"]==formRow.idx)[0].unitlist)}
                                            classNamePrefix="select2-selection"
                                            className="text-center"
                                            isLoading={false}
                                            id={"unitlist-"+key}
                                            menuPortalTarget= {document.body}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].selectedunitoption)}
                                          />
                                          {(validation["unitlist-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Please select the Unit
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Rate
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleRateChangeV2(formRow.idx, e.target.value)
                                                validateTextNumberInput("productrate-"+formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productrate)}
                                          />
                                          {(validation["productrate-"+formRow.idx] === false) &&
                                            <div className="custom-error">
                                              Enter Rate
                                            </div>
                                          }
                                        </Col>
                                        <Col xs="3">
                                          <Input
                                            type="text" //Gross
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productgross)}
                                          />
                                        </Col>
                                        
                                        
                                      </Row>
                                    </Col>
                                    <Col lg="4" xs="12">
                                      <Row className="no-gutters">
                                        <Col xs="3">
                                          <Input
                                            type="text" // Gross without tax
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productgrosswithouttax)}
                                          />
                                        </Col>
                                        {/*<Col xs="2">
                                          <Input
                                            type="text" // CGST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productcgst)}
                                          />
                                        </Col>*/
                                        /*
                                        <Col xs="2">
                                          <Input
                                            type="text" // SGST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productsgst)}
                                          />
                                        </Col>
                                        <Col xs="1">
                                          <Input
                                            type="text" //IGST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productigst)}
                                          />
                                        </Col> */}
                                        <Col xs="2">
                                          <Input
                                            type="text" // Disc
                                            className="nopadd text-center form-control"
                                            onChange={e => {
                                              if(isNumber(e.target.value)){
                                                handleDiscountChangeV2(formRow.idx, e.target.value)
                                              }
                                            }}
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productdisc)}
                                          />
                                        </Col>

                                        <Col xs="2">
                                          <Input
                                            type="text" //GST
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].productgst)}
                                          />
                                        </Col>
                                        
                                        <Col xs="3">
                                          <Input
                                            type="text" //Total
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={(salesRows.filter(x => x["idx"]==formRow.idx)[0].producttotal)}
                                          />
                                        </Col>
                                        <Col xs="2" className="justify-content-center align-self-center text-center">
                                          <div className="add-remove-mob">
                                            <Button
                                              color="info"
                                              className="btn-sm btn-info ms-0 me-1"
                                              onClick={() => {
                                                //handleAddSalesRows()
                                                addMoreDetails(formRow.idx)
                                              }}
                                              disabled={formRow.idx > 199}
                                            >
                                              <i className="fas fa-plus"></i> 
                                            </Button>
                                            <Button
                                              color="danger"
                                              className="btn-sm btn-info "
                                              onClick={() => {
                                                handleRemoveOneRow(formRow, formRow.idx)
                                              }}
                                              disabled={salesRows.length == 1}
                                            >
                                              <i className="fas fa-minus"></i> 
                                            </Button>
                                          </div>
                                        </Col>
                                      </Row>
                                    </Col>
                                    
                                  </Row>
                                  
                                </td>
                              </tr>
                            ))}
                            </SimpleBar>
                            </td></tr>

                            <tr className="">
                              <td>
                                <Row className="no-gutters me-3 custom-table-footer">
                                  <Col lg="5" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="1"></Col>
                                      <Col className="pt-1 fw-medium display-10" xs="11">Total</Col>
                                    </Row>
                                  </Col>
                                  <Col lg="3" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                            type="text" // total qty
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={salesEntry.totalqty || ''}
                                          />
                                      </Col>
                                      <Col className="" xs="3"></Col>
                                      <Col className="" xs="3"></Col>
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" //Gross
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalgross || ''}
                                        />
                                      </Col>

                                      
                                      
                                    </Row>
                                  </Col>
                                  <Col lg="4" xs="12">
                                    <Row className="no-gutters text-center">
                                      <Col className="" xs="3">
                                        <Input
                                          type="text" // net - totalgrosswithouttax
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalgrosswithouttax || ''}
                                        />
                                      </Col>
                                    {/*
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // CGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalcgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                      <Input
                                          type="text" // SGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalsgst || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="1">
                                        <Input
                                          type="text" // IGST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totaligst || ''}
                                        />
                                      </Col>*/}
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // Disc
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totaldisc || ''}
                                        />
                                      </Col>
                                      <Col className="" xs="2">
                                        <Input
                                          type="text" // GST
                                          disabled
                                          className="nopadd text-center form-control"
                                          value={salesEntry.totalgst || ''}
                                        />
                                      </Col>
                                      
                                      <Col className="" xs="5">
                                        <Input
                                            type="text" // Grand Total
                                            disabled
                                            className="nopadd text-center form-control"
                                            value={salesEntry.totaltotal.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>

                    <Row className="me-3">
                      <Col lg="3">
                        <FormGroup className="mb-1">
                          <Label>Notes</Label>
                            <textarea
                              id="pdt-notes"
                              className="form-control"
                              rows="4"
                              maxLength="500"
                              value={salesEntry.notes || ''}
                              onChange={e => {
                                setSalesEntry({
                                  ...salesEntry,
                                  notes : e.target.value
                                })
                              }}
                            />
                        </FormGroup>
                      </Col>
                      <Col lg="9">
                        <Row>
                          <Col lg="2">
                            <FormGroup className="mb-1">
                              <Label>Loading Charges</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="loading-charges"
                                  maxLength="15"
                                  value={salesEntry.loadingcharges || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      let grandtotaltemp = Number(salesEntry.totaltotal) + Number(e.target.value) + Number(salesEntry.othercharges) + Number(salesEntry.otherexpences)  - Number(salesEntry.discounts)
                                      const grandtotaltempafterround = Math.round(grandtotaltemp)
                                      const roundofftemp = grandtotaltempafterround - grandtotaltemp
                                      setSalesEntry({
                                        ...salesEntry,
                                        loadingcharges : e.target.value,
                                        balanceamount: Number(grandtotaltempafterround).toFixed(2),
                                        grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
                                        grandtotal: Number(grandtotaltempafterround).toFixed(2),
                                        roundoff: Number(roundofftemp).toFixed(2),
                                        //cashreceived: Number(grandtotaltempafterround).toFixed(2),
                                        tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-1">
                              <Label>Other Charges</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="other-charges"
                                  maxLength="20"
                                  value={salesEntry.othercharges || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      let grandtotaltemp = Number(salesEntry.totaltotal) + Number(e.target.value) + Number(salesEntry.loadingcharges) + Number(salesEntry.otherexpences)  - Number(salesEntry.discounts)
                                      const grandtotaltempafterround = Math.round(grandtotaltemp)
                                      const roundofftemp = grandtotaltempafterround - grandtotaltemp
                                      setSalesEntry({
                                        ...salesEntry,
                                        othercharges : e.target.value,
                                        balanceamount:  Number(grandtotaltempafterround).toFixed(2),
                                        grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
                                        grandtotal: Number(grandtotaltempafterround).toFixed(2),
                                        //cashreceived: Number(grandtotaltempafterround).toFixed(2),
                                        roundoff: Number(roundofftemp).toFixed(2),
                                        tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="2">
                            <FormGroup className="mb-1">
                              <Label>Other Expenses</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="other-charges"
                                  maxLength="20"
                                  value={salesEntry.otherexpences || ''}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      let grandtotaltemp = Number(salesEntry.totaltotal) + Number(e.target.value) + Number(salesEntry.loadingcharges) + Number(salesEntry.othercharges)  - Number(salesEntry.discounts)
                                      const grandtotaltempafterround = Math.round(grandtotaltemp)
                                      const roundofftemp = grandtotaltempafterround - grandtotaltemp
                                      setSalesEntry({
                                        ...salesEntry,
                                        otherexpences : e.target.value,
                                        balanceamount:  Number(grandtotaltempafterround).toFixed(2),
                                        grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
                                        grandtotal: Number(grandtotaltempafterround).toFixed(2),
                                        //cashreceived: Number(grandtotaltempafterround).toFixed(2),
                                        roundoff: Number(roundofftemp).toFixed(2),
                                        tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="3">
                            <FormGroup className="mb-1">
                              <Label>Discounts</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="sales-discounts"
                                  maxLength="20"
                                  value={salesEntry.discounts || ''}
                                  onChange={e => {
                                    let grandtotaltemp = Number(salesEntry.totaltotal) + Number(salesEntry.othercharges) + Number(salesEntry.loadingcharges) + Number(salesEntry.otherexpences)  - Number(e.target.value)
                                    const grandtotaltempafterround = Math.round(grandtotaltemp)
                                    const roundofftemp = grandtotaltempafterround - grandtotaltemp
                                    if(isNumber(e.target.value)){
                                      setSalesEntry({
                                        ...salesEntry,
                                        discounts : e.target.value,
                                        balanceamount:  Number(grandtotaltempafterround).toFixed(2),
                                        grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
                                        grandtotal: Number(grandtotaltempafterround).toFixed(2),
                                        //cashreceived: Number(grandtotaltempafterround).toFixed(2),
                                        roundoff: Number(roundofftemp).toFixed(2),
                                        tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                          <Col lg="3">
                            <FormGroup className="mb-1">
                              <Label>Round Off</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="sales-roundoff"
                                  maxLength="20"
                                  value={salesEntry.roundoff || ''}
                                  onChange={e => {
                                    let grandtotaltemp = Number(salesEntry.totaltotal) + Number(salesEntry.othercharges) + Number(salesEntry.loadingcharges) + Number(salesEntry.otherexpences)  - Number(salesEntry.discounts)
                                    let grandtotaltempafterround = Number(grandtotaltemp) + Number(e.target.value)
                                    if(isNumber(e.target.value)){
                                      setSalesEntry({
                                        ...salesEntry,
                                        grandtotalbeforeround: Number(grandtotaltemp).toFixed(2),
                                        grandtotal: Number(grandtotaltempafterround).toFixed(2),
                                        //cashreceived: Number(grandtotaltempafterround).toFixed(2),
                                        roundoff: e.target.value,
                                        tenderbalance: (Number(salesEntry.tendercash) - Number(grandtotaltempafterround)).toFixed(2),
                                      })
                                    }
                                  }}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="3">
                            <div className="mb-1 ajax-select mt-3 mt-lg-0 select2-container">
                              <Label>
                                Payment Account
                              </Label>
                              <COADropDown 
                                id={salesEntry.paymentaccountid}
                                disabled={isEdit}
                                groupCode="CH,BA"
                                accountType="CASH"
                                selectOnChange={e =>{
                                  setSalesEntry({
                                    ...salesEntry,
                                    paymentaccountid : e.value,
                                  })
                                }}
                                >
                              </COADropDown>
                            </div>
                          </Col>

                          <Col lg="3">
                            <FormGroup className="mb-1">
                              <Label>Cash Received</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="cashreceived"
                                  disabled={isEdit}
                                  maxLength="20"
                                  value={salesEntry.cashreceived.toLocaleString('en-IN',{minimumFractionDigits: 2}) || '0'}
                                  onChange={e => {
                                    if(isNumber(e.target.value)){
                                      setSalesEntry({
                                        ...salesEntry,
                                        cashreceived : e.target.value,
                                        balanceamount: (Number(salesEntry.grandtotal) - Number(e.target.value)).toFixed(2)
                                      })
                                    }
                                  }}
                                />
                                {isEdit && <Button id="disabledcashpaid" onClick={()=>{}}>
                                  <i className="bx bx-question-mark font-size-16"></i> 
                                </Button> }
                              </InputGroup>
                            </FormGroup>
                            {isEdit && <Tooltip placement="top" isOpen={tooltipOpen} target="disabledcashpaid" toggle={toggle}>
                                Please use 'Sales Receipts' to edit the Cash Paid
                            </Tooltip> }
                          </Col>
                          

                          <Col lg="3">
                            <FormGroup className="mb-1">
                              <Label>Balance Amount</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="pdt-balance-amt"
                                  disabled
                                  value={salesEntry.balanceamount.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>

                          

                          <Col lg="3">
                            <FormGroup className="mb-1">
                              <Label>Grand Total</Label>
                              <InputGroup>
                                <Input
                                  type="text"
                                  className="form-control"
                                  id="grandtotal"
                                  disabled
                                  value={salesEntry.grandtotal.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                />
                              </InputGroup>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      
                    </Row>
                    <Row>
                      <Col lg="3">
                      </Col>
                      <Col lg="9">
                      <Row>
                        <Col lg="3">
                          <FormGroup className="mb-1">
                            <Label>Tender Cash</Label>
                            <InputGroup>
                              <Input
                                type="text"
                                className="form-control"
                                id="tenderCash"
                                maxLength="20"
                                value={salesEntry.tendercash.toLocaleString('en-IN',{minimumFractionDigits: 2}) || ''}
                                onChange={e => {
                                  if(isNumber(e.target.value)){
                                    setSalesEntry({
                                      ...salesEntry,
                                      tendercash : e.target.value,
                                      tenderbalance: (Number(e.target.value) - Number(salesEntry.grandtotal)).toFixed(2)
                                    })
                                  }
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup className="mb-1">
                            <Label>Tender Balance</Label>
                            <InputGroup>
                              <Input
                                type="text"
                                className="form-control"
                                id="tender-balance-amt"
                                disabled
                                value={Number(salesEntry.tendercash) > 0 ? salesEntry.tenderbalance.toLocaleString('en-IN',{minimumFractionDigits: 2}) : '0'}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>
                      </Row>
                      </Col>
                    </Row>
                    

                    {(validation["invalidsum"] === false) &&
                      <div className="text-center clearfix custom-error mb-3">
                        Grand Total & Invoice Total doesnt match. Please check.
                      </div>
                    }
                    
                    {!isEdit &&
                    <Row className="mt-2">
                      <Col md="3" className=" align-self-center">
                      </Col>
                      <Col md="6">
                      <div className="text-center clearfix">
                        {!savedSuccessFully && <Button
                          color="success"
                          className="btn w-lg btn-success me-2"
                          disabled={savedSuccessFully}
                          onClick={() => {
                            addSalesEntry()
                          }}
                          >
                            SAVE SALE
                        </Button>
                        }
                        {!savedSuccessFully && <Button
                          color="secondary"
                          className="btn w-lg btn-info me-2"
                          onClick={() => {
                            draftSalesEntry()
                          }}
                          >
                            SAVE AS DRAFT
                        </Button>
                        }
                        {savedSuccessFully && <Button
                          color="secondary"
                          className="btn w-lg btn-info me-2"
                          onClick={() => {
                            onContinueEditing()
                          }}
                          >
                            EDIT
                        </Button>
                        }
                        {savedSuccessFully && <Button
                          color="primary"
                          className="btn w-lg btn-primary me-2"
                          id={"sales-addnew-id-2"}
                          onClick={() => {
                            addNewSales()
                          }}
                          >
                            ADD NEW SALES
                        </Button> }
                        {savedSuccessFully && <Button
                          color="info"
                          className="btn btn-info me-2"
                          id={"sales-print-id-2"}
                          onClick={() => {
                            handlePrint()
                          }}
                          >
                            <i className="bx bx-printer me-1"></i> Print
                        </Button>
                        }
                        </div>
                      </Col>
                      <Col md="3">
                      </Col>
                    </Row>
                    }
                    
                    {isEdit &&
                    <Row className="mt-2">
                      <Col className=" align-self-center">
                      </Col>
                      <Col>
                        <div className="text-center clearfix">
                          <Button
                            color="success"
                            className="btn w-lg btn-success me-2"
                            onClick={() => {
                              updateSalesEntry()
                            }}
                            >
                              SAVE SALE
                          </Button>
                          {salesEntry.status == "DRAFT" ? <Button
                            color="secondary"
                            className="btn w-lg btn-info me-2"
                            onClick={() => {
                              updateDraftSalesEntry()
                            }}
                            >
                              SAVE AS DRAFT
                          </Button>
                          : null
                          }
                          <Button
                            color="info"
                            className="btn btn-info me-2"
                            onClick={() => {
                              handlePrint()
                            }}
                            >
                              <i className="bx bx-printer me-1"></i>Print
                          </Button>
                        </div>
                      </Col>
                      <Col className="justify-content-end d-flex">
                      </Col>
                    </Row>
                    }
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightDrawer 
          onClose={onDrawerClose} 
          currentItem={newItemToAdd} 
          onNewlyAddedValue={onNewlyAddedValue}
          enteredText={enteredText}
        />
      </ReactDrawer>

      {showWarningPopUp ? (
        <SweetAlert
          warning
          title="Warning"
          onConfirm={() => {
            setShowWarningPopUp(false)
          }}
        >
          {warningMessage}
        </SweetAlert>
      ) : null}

      {showErrorPopUp ? (
        <SweetAlert
          error
          title="Failed"
          onConfirm={() => {
            setShowErrorPopUp(false)
          }}
        >
          {errorMessage}
        </SweetAlert>
      ) : null}
      {showSuccessPopUp ? (
        <SweetAlert
          title="Success!"
          success
          customButtons={
            <>
            <Button
              color="primary"
              className="btn btn-primary me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                onCreateNewSales()
              }}
              >
                <i className="bx bx-plus me-1"></i>Add New Sales
            </Button>
            <Button
              color="info"
              id={'sales-print-id'}
              className="btn btn-info me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
                handlePrint()
                document.getElementById('sales-addnew-id-2').focus();
              }}
              >
                <i className="bx bx-printer me-1"></i>Print
            </Button>
            <Button
              color="warning"
              className="btn btn-warning me-2"
              onClick={() => {
                setShowSuccessPopUp(false)
              }}
              >
                <i className="bx bx-window-close me-1"></i>Close
            </Button>
            </>
          }
          onConfirm={() => {
            setShowSuccessPopUp(false)
          }}
        >
          {successMessage}
        </SweetAlert>
      ) : null}


      {((savedSuccessFully || isEdit) && printerPageSetting == 'A4-P') &&
        <InvoiceDetailV4
        salesDetails={salesEntry}
        storeDetails={storeDetails}
        customerDetails={selectedCustomer}
        fromSales={true}
        settings={settings}
        ref={componentRef}
        />
        }

      {((savedSuccessFully || isEdit) && printerPageSetting == 'A5-P') &&
        <InvoiceDetailV5 
        salesDetails={salesEntry}
        storeDetails={storeDetails}
        customerDetails={selectedCustomer}
        fromSales={true}
        settings={settings}
        ref={componentRef}
        />
        }

      {((savedSuccessFully || isEdit) && printerPageSetting == 'A5-L') &&
        <div className="pb-4 mb-3">
          <InvoiceDetailA5L 
          salesDetails={salesEntry}
          storeDetails={storeDetails}
          customerDetails={selectedCustomer}
          fromSales={true}
          settings={settings}
          ref={componentRef}
          />
        </div>
        }

    </React.Fragment>
  )
}

export default SalesEntry
